export enum ToggleBarLayoutMode {
	SingleLine = 'singleLine',
	MultiLine = 'multiLine',
}
